module.exports = __webpack_public_path__ + "static/media/291783.809d90e4.png";